import Home from "../components/Home";

const HomePage = () => {
  //http request

  return <Home />;
};
export default HomePage;
